export default () => {
	const app = useNuxtApp()
	return {
		thousandFormat(value: any, def: any = ""): any {
			if (!value) return def
			let v = ((value || "") + "") as string
			let v2 = ""
			let m = false
			if (v.includes(".")) {
				const i = v.indexOf(".")
				v2 = v.substring(i, v.length)
				v = v.substring(0, i)
			}
			if (v.includes("-")) {
				v = v.replace("-", "")
				m = true
			}
			v = v
				.replace(/,/g, "")
				.split("")
				.reverse()
				.join("")
				.replace(/(...)/g, "$1,")
				.split("")
				.reverse()
				.join("")
				.replace(/^,+|,+$/, "")
			if (m) v = "-" + v
			return v + v2
		},
		arabicToPersian(value: string): string {
			if (!value) return ""
			const characters = {
				// letters
				ك: "ک",
				ى: "ی",
				ي: "ی",
				أ: "ا",
				آ: "آ",
				إ: "ا",
				ة: "ه",
				// numbers
				"٠": "۰",
				"١": "۱",
				"٢": "۲",
				"٣": "۳",
				"٤": "۴",
				"٥": "۵",
				"٦": "۶",
				"٧": "۷",
				"٨": "۸",
				"٩": "۹",
				// vowels
				"َ": "",
				"ً": "",
				"ُ": "",
				"ٌ": "",
				"ِ": "",
				"ٍ": "",
				"ْ": "",
				"ّ": ""
			} as any
			return value
				.split("")
				.map((v) => characters[v] || v)
				.join("")
		},
		ennum(value: string): string {
			const characters = {
				"۱": "1",
				"۲": "2",
				"۳": "3",
				"۴": "4",
				"۵": "5",
				"۶": "6",
				"۷": "7",
				"۸": "8",
				"۹": "9",
				"۰": "0"
			} as any
			return this.arabicToPersian(value)
				.split("")
				.map((v) => characters[v] || v)
				.join("")
		},
		getLocalText: <T extends { [key: string]: string } | string | number | null>(text?: T): string | undefined => {
			if (typeof text != "object") return text as any
			return (
				text?.[app.$i18n.locale.value] ||
				text?.en ||
				Object.values(text || {})?.filter((v) => v)[0] ||
				undefined
			)
		},
		encodeSimpleMinutes(minutes: number | null | undefined) {
			const m = Math.floor((minutes || 0) % 60)
			const h = Math.floor((minutes || 0) / 60)
			let s = ""
			if (h) s += h + "h "
			if (m) s += m + "m"
			return s.trim() || "0m"
		},
		decodeSimpleMinutes(formattedMinutes: string | null | undefined) {
			let s = String(formattedMinutes || "")
				.toLowerCase()
				.trim()
			if (!s.endsWith("h") && !s.endsWith("m")) s += "h"
			const parts = s.match(/((\d+\.*\d*)h)?\s*((\d+\.*\d*)m)?/i)
			const h = Number(parts?.[2]) || 0
			const m = Number(parts?.[4]) || 0
			return Math.floor(h * 60 + m)
		},
		formatDuration(seconds?: number) {
			if (!seconds) return ""
			const hours = Math.floor(seconds / 3600)
			const minutes = Math.floor((seconds % 3600) / 60)
			const secs = seconds % 60

			if (hours > 0) {
				return `${hours}:${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`
			}
			return `${minutes}:${secs.toString().padStart(2, "0")}`
		}
	}
}
